import { Navigate } from 'react-router-dom';

export default function ProtectedAdminRoute({ isAdmin, children }) {
  if (isAdmin === null) return null; // ou un loader
  if (!isAdmin) return <Navigate to="/login-admin" replace />;
  return children;
}